import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=6c964a0b&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=ts"
export * from "./Drafts.vue?vue&type=script&lang=ts"
import style0 from "./Drafts.vue?vue&type=style&index=0&id=6c964a0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c964a0b",
  null
  
)

export default component.exports